<template>
  <div :class="['edu-navbar-area navbar-area', { 'is-sticky': isSticky }]">
    <div class="cvision-nav">
      <div class="container">
        <nav class="navbar navbar-expand-lg navbar-light">
          <router-link class="navbar-brand" to="/">
            <img src="../../assets/img/logo/cvision.svg" alt="logo" />
          </router-link>

          <!-- Mobil Menü Butonu -->
          <div class="navbar-toggler" @click="active = !active" :aria-pressed="active ? 'true' : 'false'"
            :class="{ active: button_active_state }" @click.stop="button_active_state = !button_active_state">
            <i class="bx bx-menu"></i>
            <i class="bx bx-x"></i>
          </div>

          <!-- Menü -->
          <div class="collapse navbar-collapse" :class="{ show: active }">
            <ul class="navbar-nav">

              <!-- Anasayfa -->
              <li class="nav-item">
                <router-link to="/" class="nav-link">Anasayfa</router-link>
              </li>

              <li class="nav-item">
                <router-link to="/about" class="nav-link">Hakkımızda</router-link>
              </li>
              <li class="nav-item">
                <router-link to="/instructor" class="nav-link">Eğitmen Kadromuz</router-link>
              </li>



              <!-- Sayfalar (Dropdown) 
              <li class="nav-item dropdown" @click="toggleDropdown('sayfalar')">
                <a href="javascript:void(0)" class="nav-link dropdown-toggle">
                  Sayfalar
                </a>
                <ul class="dropdown-menu" v-show="openDropdown === 'sayfalar'">
               
                </ul>
              </li>
              -->

              <li class="nav-item">
                <router-link to="/courses" class="nav-link">Kurslar</router-link>
              </li>

              <!-- İletişim (Tek sayfa, ok yok) -->
              <li class="nav-item">
                <router-link to="/contact" class="nav-link">İletişim</router-link>
              </li>
            </ul>
          </div>

          <!-- Buton -->
          <div class="nav-btn">
            <router-link to="/contact" class="default-btn">
              Hemen İletişime Geç
            </router-link>
          </div>
        </nav>
      </div>
    </div>
  </div>
</template>


<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "MainNavbar",
  data() {
    return {
      isSticky: false,
      active: false,
      button_active_state: false,
      openDropdown: null, // hangi dropdown açık
    };
  },
  methods: {
    toggleDropdown(menu) {
      this.openDropdown = this.openDropdown === menu ? null : menu;
    },
  },
  mounted() {
    window.addEventListener("scroll", () => {
      const scrollPos = window.scrollY;
      this.isSticky = scrollPos >= 100;
    });
  },
});
</script>

<style scoped>
/* Bootstrap’in default arrow’unu kapat */
.navbar-nav .dropdown-toggle::after {
  display: none !important;
}
</style>
